import { Box, Flex, Text } from '@chakra-ui/react';

interface SupplierSyncCoverageProps {
  synced: number;
  total: number;
}

export function SupplierSyncCoverage({
  synced,
  total,
}: SupplierSyncCoverageProps) {
  const percentage = total === 0 ? 0 : Math.round((synced / total) * 100);
  const color =
    percentage === 0
      ? 'texas.danger.200'
      : percentage < 80
      ? 'texas.warning.100'
      : 'entities.supplier';

  return (
    <Flex align="center" gap={2}>
      <Box
        bg="entityDirectory.progressTrack"
        h="4px"
        overflow="hidden"
        w="90px"
      >
        <Box bg={color} h="full" w={`${percentage}%`} />
      </Box>
      <Text fontSize="12px" fontWeight="semibold" minW="36px">
        {percentage}%
      </Text>
    </Flex>
  );
}
